import {useRef} from 'react'
import classes from './PreScannedPage.module.scss'
import { DirectionService } from '../../api/directionService';

const PreScannedPage = ({input, onClose}) => {

  const iframeRef = useRef(null);

  const showResult = async(id) => {
          await DirectionService.getDirectionHTML(id).then(res=>{
              if (res?.data){
                  const iframe = iframeRef.current;
                  const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
  
                  iframeDoc.open();
                  iframeDoc.write(res?.data);
                  iframeDoc.close();
              }
          })
    }
    
  
    if(input){
      showResult(input)
    }

    const closeWindow = () => {
        onClose(false)
    }

  return (
    <div className={classes.container}>
      <iframe className={classes.box} ref={iframeRef} title='Before sign'/>
      <button className={classes.closeButton}  onClick={closeWindow}>X</button>
    </div>
  )
}

export default PreScannedPage